import React, { useState, useEffect } from "react";
import { Container, Row, Col, FormGroup, Label, Input, Table } from "reactstrap";
import { Formik, Form } from "formik";
import { useSearchParams, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { NumberWithCommas } from "../share/NumberWithCommas";

export function CheckBorrowSixComponent() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const user = JSON.parse(localStorage.getItem("userData"));
    // console.log("user", user?.fullName);
    const borrowId = searchParams.get("req");

    // ----- UI / Data states -----
    const [dataBorrowSixTest, setBorrowSixTest] = useState(null);
    const [dataTdPaymentTest, setDataTdPaymentTest] = useState([]);
    const [dataTdPaymentTrain, setDataTdPaymentTrain] = useState([]);
    const [sumTdPayment, setSumTdPayment] = useState(0);

    const [dataTdTrainTests, setDataTdTrainTests] = useState([]); // ตารางหลักสูตร (ฝึก/ทดสอบ)
    const [sumTdTrainTests, setSumTdTrainTests] = useState({
        paymentAmount: 0,
        personTotal: 0,
        actualPayment: 0,
        actualPerson: 0,
        passPerson: 0,
        balanceAmount: 0,
    });

    const [checkTestFinish, setCheckTestFinish] = useState(null);
    const [checkTrainFinish, setCheckTrainFinish] = useState(null);
    const [disableButton, setDisableButton] = useState(true);

    // checkbox เหตุผลข้อ 1 (ติ๊กหลายข้อได้)
    const [checkedTypeBorrow, setCheckedTypeBorrow] = useState([
        { id: "1", name: "one", check: false, var: "(1) เพื่อพัฒนาพนักงานให้มีทักษะ ความรู้มากขึ้น" },
        { id: "2", name: "two", check: false, var: "(2) เพื่อวัดระดับทักษะฝีมือของพนักงาน" },
        { id: "3", name: "three", check: false, var: "(3) เพื่อปรับเปลี่ยนตำแหน่ง หน้าที่ ของพนักงาน" },
        { id: "4", name: "four", check: false, var: "(4) เพื่อสร้างความก้าวหน้าในสายอาชีพแก่พนักงาน" },
        { id: "5", name: "five", check: false, var: "(5) เพื่อเพิ่มขีดความสามารถในการแข่งขันของบริษัท" },
        { id: "6", name: "six", check: false, var: "(6) เพื่อเพิ่มประสิทธิภาพการผลิต" },
        { id: "7", name: "seven", check: false, var: "(7) เพื่อลดต้นทุนการผลิต" },
        { id: "8", name: "eight", check: false, var: "(8) เพื่อร่วมมือกับภาครัฐพัฒนาทักษะฝีมือแรงงาน" },
    ]);

    // ----- Initial Values สำหรับ Formik (จะถูก set จาก API) -----
    const emptyInitial = {
        RegisterId: user?.registerId,
        BorrowId: borrowId,
        BorrowReason1: [],

        BorrowReason2P1: 0, BorrowReason2P2: 0, BorrowReason2P3: 0, BorrowReason2P4: 0,
        BorrowReason2P5: 0, BorrowReason2P6: 0, BorrowReason2P7: 0, BorrowReason2P8: 0,

        BorrowReason3P1: 0, BorrowReason3P2: 0, BorrowReason3P3: 0, BorrowReason3P4: 0,
        BorrowReason3P5: 0, BorrowReason3P6: 0, BorrowReason3P7: 0,

        BorrowReason4P1: 0, BorrowReason4P2: 0, BorrowReason4P3: 0, BorrowReason4P4: 0,
        BorrowReason4P5: 0, BorrowReason4P6: 0, BorrowReason4P7: 0,

        BorrowReason51: 0, BorrowReason511: "",
        BorrowReason52: 0, BorrowReason521: 0, BorrowReason522: "",
        BorrowReason53: 0, BorrowReason531: "",
        BorrowReason54: 0, BorrowReason541: "",
        BorrowReason55: "", BorrowReason56: "",

        SumTdActualPayment: 0,
        TdTrainTests: [],
        fActualExpensePath: "", // file input ใส่ค่าไม่ได้—ใช้สำหรับส่งกลับ
    };

    const [initialValues, setInitialValues] = useState(emptyInitial);

    // ----- Validation -----
    const zipCT = [
        "application/zip",
        "application/octet-stream",
        "application/x-zip-compressed",
        "multipart/x-zip",
        "application/vnd.rar",
        "application/x-rar-compressed",
        "application/octet-stream",
    ];

    const validateSchema = Yup.object().shape({
        BorrowReason1: Yup.array().min(1, "กรุณาเลือกอย่างน้อย 1 รายการ"),
        SumTdActualPayment: Yup.number().min(1, "กรุณาระบุ"),

        BorrowReason2P1: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P2: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P3: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P4: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P5: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P6: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P7: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P8: Yup.number().min(1, "กรุณาระบุ"),

        BorrowReason3P1: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P2: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P3: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P4: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P5: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P6: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P7: Yup.number().min(1, "กรุณาระบุ"),

        BorrowReason4P1: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P2: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P3: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P4: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P5: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P6: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P7: Yup.number().min(1, "กรุณาระบุ"),

        BorrowReason51: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason511: Yup.string(),

        BorrowReason52: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason521: Yup.number(),
        BorrowReason522: Yup.string(),

        BorrowReason53: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason531: Yup.string(),

        BorrowReason54: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason541: Yup.string().when("BorrowReason54", {
            is: 3,
            then: Yup.string().required("กรุณาระบุ"),
        }),

        BorrowReason55: Yup.string(),
        BorrowReason56: Yup.string(),

        TdTrainTests: Yup.array(),
        BorrowId: Yup.number(),

        fActualExpensePath: Yup.mixed()
            .test("fileFormat", "เฉพาะไฟล์ชนิด .zip หรือ .rar", (value) => {
                if (!value) return true; // ถ้าไม่อัปโหลดใหม่ ให้ผ่าน (เพราะเป็นเคสแก้ไข)
                return value && zipCT.includes(value.type);
            }),
    });

    // ----- Helpers -----
    function SumTdTrainTestsFX(list) {
        const acc = {
            paymentAmount: 0,
            personTotal: 0,
            actualPayment: 0,
            actualPerson: 0,
            passPerson: 0,
            balanceAmount: 0,
        };
        (list || []).forEach((row) => {
            acc.paymentAmount += Number(row.paymentAmount || 0);
            acc.personTotal += Number(row.personTotal || 0);
            acc.actualPayment += Number(row.actualPayment || 0);
            acc.actualPerson += Number(row.actualPerson || 0);
            acc.passPerson += Number(row.passPerson || 0);
            acc.balanceAmount += Number(row.balanceAmount || 0);
        });
        return acc;
    }

    // ----- Load Data -----
    useEffect(() => {
        GetBorrowSixTest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const submitFormBorrowSix = async () => {
        try {
            let postData = new FormData();
            postData.append("borrowId", Number(borrowId));
            postData.append("userApprove", user?.fullName);


            let res = await fetch("/api/Borrow/submitBorrowSix", {
                method: "POST",
                body: postData
            });

            let resJson = await res.json();

            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((r) => {
                    if (r.isConfirmed) navigate(`/borrowing/`);
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message || "-"}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }

        } catch (e) {

        }
    }

    async function GetBorrowSixTest() {
        try {
            const postData = new FormData();
            postData.append("borrowId", borrowId);

            const res = await fetch("/api/Borrow/getBorrowSixTest", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();

            // NOTE: สมมติ Controller คืน { status: 1, dataenum: {...} }
            const dto = data?.dataenum || data; // กันกรณีบางระบบคืนตรง ๆ

            setBorrowSixTest(dto);
            setCheckTestFinish(dto?.checkTestFinish || null);
            setCheckTrainFinish(dto?.checkTrainFinish || null);

            // ตาราง train/test
            const rows = dto?.tdTrainTests || [];
            setDataTdTrainTests(rows);
            setSumTdTrainTests(SumTdTrainTestsFX(rows));

            // สรุปยอดกู้ตามสัญญา
            const payments = dto?.tdPayments || [];
            setDataTdPaymentTrain(payments.filter((p) => p.paymentTypeId === 1));
            setDataTdPaymentTest(payments.filter((p) => p.paymentTypeId === 2));
            setSumTdPayment(
                payments.reduce((s, x) => s + Number(x?.amountApprove || 0), 0)
            );

            // ถ้าเคยส่งฟอร์มแล้ว (ตัวอย่างเดิมของคุณ)
            // if (dto?.checkSendForms) {
            //     Swal.fire({
            //         icon: "info",
            //         title: "คุณได้นำส่งแบบติดตามประเมินผลการให้กู้ยืมเรียบร้อยแล้ว",
            //         confirmButtonColor: "#0A66C2",
            //         confirmButtonText: "ตกลง",
            //     }).then((r) => {
            //         if (r.isConfirmed) navigate(`/borrowing/`);
            //     });
            // }

            // เซ็ตค่า initial จากคำตอบเดิม
            setInitialValues((prev) => ({
                ...prev,
                RegisterId: user?.registerId,
                BorrowId: borrowId,

                BorrowReason1: dto?.borrowReason1 || [],

                BorrowReason2P1: dto?.borrowReason2P1 ?? 0,
                BorrowReason2P2: dto?.borrowReason2P2 ?? 0,
                BorrowReason2P3: dto?.borrowReason2P3 ?? 0,
                BorrowReason2P4: dto?.borrowReason2P4 ?? 0,
                BorrowReason2P5: dto?.borrowReason2P5 ?? 0,
                BorrowReason2P6: dto?.borrowReason2P6 ?? 0,
                BorrowReason2P7: dto?.borrowReason2P7 ?? 0,
                BorrowReason2P8: dto?.borrowReason2P8 ?? 0,

                BorrowReason3P1: dto?.borrowReason3P1 ?? 0,
                BorrowReason3P2: dto?.borrowReason3P2 ?? 0,
                BorrowReason3P3: dto?.borrowReason3P3 ?? 0,
                BorrowReason3P4: dto?.borrowReason3P4 ?? 0,
                BorrowReason3P5: dto?.borrowReason3P5 ?? 0,
                BorrowReason3P6: dto?.borrowReason3P6 ?? 0,
                BorrowReason3P7: dto?.borrowReason3P7 ?? 0,

                BorrowReason4P1: dto?.borrowReason4P1 ?? 0,
                BorrowReason4P2: dto?.borrowReason4P2 ?? 0,
                BorrowReason4P3: dto?.borrowReason4P3 ?? 0,
                BorrowReason4P4: dto?.borrowReason4P4 ?? 0,
                BorrowReason4P5: dto?.borrowReason4P5 ?? 0,
                BorrowReason4P6: dto?.borrowReason4P6 ?? 0,
                BorrowReason4P7: dto?.borrowReason4P7 ?? 0,

                BorrowReason51: dto?.borrowReason51 ?? 0,
                BorrowReason511: dto?.borrowReason511 || "",
                BorrowReason52: dto?.borrowReason52 ?? 0,
                BorrowReason521: dto?.borrowReason521 ?? 0,
                BorrowReason522: dto?.borrowReason522 || "",
                BorrowReason53: dto?.borrowReason53 ?? 0,
                BorrowReason531: dto?.borrowReason531 || "",
                BorrowReason54: dto?.borrowReason54 ?? 0,
                BorrowReason541: dto?.borrowReason541 || "",
                BorrowReason55: dto?.borrowReason55 || "",
                BorrowReason56: dto?.borrowReason56 || "",

                SumTdActualPayment:
                    dto?.sumTdActualPayment ?? Number(dto?.actualPayment || 0) ?? 0,

                TdTrainTests: rows,
            }));

            // ติ๊ก checkbox เดิมให้ตรง BorrowReason1
            if (Array.isArray(dto?.borrowReason1)) {
                const next = checkedTypeBorrow.map((x) => ({
                    ...x,
                    check: dto.borrowReason1.includes(x.id),
                }));
                setCheckedTypeBorrow(next);
            }
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "โหลดข้อมูลไม่สำเร็จ",
                text: "กรุณาลองใหม่อีกครั้ง",
            });
        }
    }

    // ----- ปุ่มบันทึก: เงื่อนไขปิด/เปิด -----
    useEffect(() => {
        // ถ้าอันใดอันหนึ่ง notpass → disable
        if (!checkTestFinish && checkTrainFinish) {
            setDisableButton(checkTrainFinish?.trainFinish === "notpass");
        } else if (!checkTrainFinish && checkTestFinish) {
            setDisableButton(checkTestFinish?.testFinish === "notpass");
        } else if (checkTestFinish && checkTrainFinish) {
            setDisableButton(
                checkTestFinish?.testFinish === "notpass" ||
                checkTrainFinish?.trainFinish === "notpass"
            );
        } else {
            setDisableButton(true);
        }
    }, [checkTestFinish, checkTrainFinish]);



    // ----- Event handlers ภายในฟอร์ม -----
    // สรุป checkbox เป็น BorrowReason1 (["1","3",...])
    const SelectType = (types, setFieldValue) => {
        const filtered = types.filter((t) => t.check === true);
        const result = filtered.map(({ id }) => id);
        setFieldValue("BorrowReason1", result);
    };

    const HandleChecked = (e, setFieldValue) => {
        const { value, checked } = e.target;
        const idx = checkedTypeBorrow.findIndex((t) => t.id === value);
        if (idx >= 0) {
            const next = [...checkedTypeBorrow];
            next[idx].check = checked;
            setCheckedTypeBorrow(next);
            SelectType(next, setFieldValue);
        }
    };

    // อัปเดตค่าช่องในตาราง + รวมผลรวม
    const setValueTrainTests = (e, values, setFieldValue) => {
        const getPaymentType = e.target.id[1]; // a1_123 → '1'
        const getInputType = e.target.id[0];   // 'a' | 'p' | 'r'
        const getItemId = e.target.id.split("_")[1];

        const updated = (dataTdTrainTests || []).map((item) => {
            if (String(item.paymentTypeId) === String(getPaymentType) && String(item.itemId) === String(getItemId)) {
                const val = Number(e.target.value || 0);
                if (getInputType === "a") {
                    item.actualPayment = val;
                    item.balanceAmount = Number(item.paymentAmount || 0) - Number(item.actualPayment || 0);
                } else if (getInputType === "p") {
                    item.actualPerson = val;
                } else if (getInputType === "r") {
                    item.passPerson = val;
                }
            }
            return item;
        });

        setDataTdTrainTests(updated);
        setSumTdTrainTests(SumTdTrainTestsFX(updated));
        setFieldValue("TdTrainTests", updated);
    };

    return (
        <Formik
            // onSubmit={onSubmit}
            initialValues={initialValues}
            // validationSchema={validateSchema}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                setFieldValue,
                submitForm,
                setFieldError,
            }) => {
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        <div className="form-border">
                            <Form className="p-5 mb-4">
                                {/* Header */}
                                <Label className="me-4 input-color">ประเภทผู้กู้ยืมเงิน</Label>
                                <FormGroup className="px-3">
                                    <Col>
                                        {dataBorrowSixTest?.borrowType?.map((t, i) => (
                                            <p key={i} className="text-center rounded-pill border py-1 input-color">
                                                {t?.typeName}
                                            </p>
                                        ))}
                                    </Col>
                                </FormGroup>

                                <Label className="me-4 input-color">ส่วนที่ 1 ข้อมูลทั่วไป</Label>
                                <div className="p-3">
                                    <FormGroup>
                                        <Label>ชื่อผู้กู้ยืม</Label>
                                        <Col>
                                            <p className="text-center rounded-pill border py-1 input-color">
                                                {dataBorrowSixTest?.borrowName || "-"}
                                            </p>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>เลขที่สัญญา</Label>
                                        <Col>
                                            <p className="text-center rounded-pill border py-1 input-color">
                                                {dataBorrowSixTest?.contactNumber || "-"}
                                            </p>
                                        </Col>
                                    </FormGroup>
                                </div>

                                {/* Checkbox: เหตุผลข้อ 1 */}
                                <Label className="me-4 input-color">
                                    เหตุผลของการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเป็นค่าใช้จ่ายในการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                    (ตอบได้มากกว่า 1 ข้อ)
                                    {errors.BorrowReason1 ? (
                                        <span className="text-left text-danger mx-1">{errors.BorrowReason1}</span>
                                    ) : null}
                                </Label>
                                <div className="d-flex justify-content-around flex-column">
                                    {checkedTypeBorrow.map((opt) => (
                                        <FormGroup className="mx-2" key={opt.id}>
                                            <Input
                                                id={opt.name}
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value={opt.id}
                                                disabled
                                                name={opt.name}
                                                checked={opt.check}
                                                onChange={(e) => HandleChecked(e, setFieldValue)}
                                            />
                                            <Label>{opt.var}</Label>
                                        </FormGroup>
                                    ))}
                                </div>

                                {/* จำนวนเงินกู้ตามสัญญา */}
                                <FormGroup>
                                    <Label>จำนวนเงินกู้ตามสัญญา</Label>
                                    <Col>
                                        <p className="text-center rounded-pill border py-1 input-color">
                                            {NumberWithCommas(sumTdPayment)} บาท
                                        </p>
                                    </Col>
                                </FormGroup>

                                {/* Train Summary */}
                                <div className="p-3">
                                    <FormGroup>
                                        <Label>
                                            ดำเนินการฝึกอบรมฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                                        </Label>
                                        <Row className="pt-3 mx-3">
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={1}>
                                                {dataTdPaymentTrain[0]?.course ?? "-"}
                                            </Col>
                                            <Label sm={2}>หลักสูตร</Label>
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={2}>
                                                {dataTdPaymentTrain[0]?.personTotal ?? "-"}
                                            </Col>
                                            <Label sm={2}>คน</Label>
                                        </Row>
                                    </FormGroup>
                                </div>

                                {/* Test Summary */}
                                <div className="p-3">
                                    <FormGroup>
                                        <Label>
                                            ดำเนินการทดสอบมาตรฐานฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                                        </Label>
                                        <Row className="pt-3 mx-3">
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={1}>
                                                {dataTdPaymentTest[0]?.course ?? "-"}
                                            </Col>
                                            <Label sm={2}>สาขาอาชีพ</Label>
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={2}>
                                                {dataTdPaymentTest[0]?.personTotal ?? "-"}
                                            </Col>
                                            <Label sm={2}>คน</Label>
                                        </Row>
                                    </FormGroup>
                                </div>

                                {/* การใช้จ่ายจริง (SumTdActualPayment) */}
                                <FormGroup>
                                    <Label>
                                        การใช้จ่ายเงินกู้ตามที่เบิกจ่ายจริง (บาท)
                                        {errors.SumTdActualPayment ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.SumTdActualPayment}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Col>
                                        <Input
                                            type="text"
                                            className="text-center input-color rounded-pill"
                                            name="SumTdActualPayment"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.SumTdActualPayment}
                                            disabled
                                        />
                                    </Col>
                                    {/* แสดงลิงก์ไฟล์เดิม ถ้ามี (file input ตั้งค่าล่วงหน้าไม่ได้) */}
                                    {(dataBorrowSixTest?.fActualPaymentPathView ||
                                        dataBorrowSixTest?.FActualPaymentPathView) && (
                                            <div className="mt-2">
                                                <a
                                                    href={
                                                        "/" +
                                                        (dataBorrowSixTest?.fActualPaymentPathView ||
                                                            dataBorrowSixTest?.FActualPaymentPathView)
                                                    }
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    ดูไฟล์หลักฐานเดิม
                                                </a>
                                            </div>
                                        )}
                                </FormGroup>

                                {/* ===== ส่วนที่ 2 ===== */}
                                <Label className="input-color pt-3">
                                    ส่วนที่ 2 ประโยชน์ที่ผู้ประกอบกิจการได้รับจากการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                    เพื่อดำเนินการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                {[
                                    { key: "BorrowReason2P1", text: "1.ลดต้นทุน/ลดการสูญเสียในการผลิต" },
                                    { key: "BorrowReason2P2", text: "2.เพิ่มผลิตภาพการผลิตสินค้า/บริการ" },
                                    { key: "BorrowReason2P3", text: "3.สินค้า/บริการ มีคุณภาพดีขึ้น" },
                                    { key: "BorrowReason2P4", text: "4.เพิ่มความสามารถในการแข่งขันของบริษัท" },
                                    { key: "BorrowReason2P5", text: "5.พนักงานมีทักษะ ความรู้ ความชำนาญเพิ่มขึ้น" },
                                    { key: "BorrowReason2P6", text: "6.ความผิดพลาดในการทำงานลดลง" },
                                    { key: "BorrowReason2P7", text: "7.สามารถจำแนกระดับความรู้ความสามารถพนักงานในองค์กร" },
                                    { key: "BorrowReason2P8", text: "8.สามารถปรับเพิ่มเงินเดือน เลื่อนตำแหน่งตามทักษะฯ" },
                                ].map(({ key, text }) => (
                                    <div className="d-flex justify-content-between border rounded-pill m-1" key={key}>
                                        <div className="mx-3 pt-2">
                                            {text}
                                            {errors[key] ? (
                                                <span className="text-left text-danger mx-1">{errors[key]}</span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id={key}
                                            name={key}
                                            type="select"
                                            className="rounded-pill w-auto text-center input-color"
                                            onBlur={handleBlur}
                                            disabled
                                            onChange={handleChange}
                                            value={values[key]}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                ))}

                                {/* ===== ส่วนที่ 3 ===== */}
                                <Label className="me-4 pt-3 input-color">
                                    ส่วนที่ 3 ประโยชน์ที่พนักงานได้รับจากการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                {[
                                    { key: "BorrowReason3P1", text: "1.มีทักษะความรู้ความชำนาญในงานที่ทำเพิ่มขึ้น" },
                                    { key: "BorrowReason3P2", text: "2.รู้ระดับความสามารถของตนเองเพื่อพัฒนาสมรรถนะที่ขาด" },
                                    { key: "BorrowReason3P3", text: "3.พัฒนาความรู้ความสามารถทันต่อเทคโนโลยี" },
                                    { key: "BorrowReason3P4", text: "4.สามารถถ่ายทอดความรู้และสอนงานในพนักงานในองค์กร" },
                                    { key: "BorrowReason3P5", text: "5.การทำงานแบบระบบมีประสิทธิภาพเพิ่มขึ้น" },
                                    { key: "BorrowReason3P6", text: "6.สามารถแก้ไขปัญหาข้อขัดข้องในการปฎิบัติงานได้" },
                                    { key: "BorrowReason3P7", text: "7.ได้รับการปรับเพิ่มเงินเดือน เลื่อนตำแหน่งงานสูงขึ้น" },
                                ].map(({ key, text }) => (
                                    <div className="d-flex justify-content-between border rounded-pill m-1" key={key}>
                                        <div className="mx-3 pt-2">
                                            {text}
                                            {errors[key] ? (
                                                <span className="text-left text-danger mx-1">{errors[key]}</span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id={key}
                                            name={key}
                                            type="select"
                                            className="rounded-pill w-auto text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            disabled
                                            value={values[key]}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                ))}

                                {/* ===== ส่วนที่ 4 ===== */}
                                <Label className="me-4 pt-3 input-color">
                                    ส่วนที่ 4 ประโยชน์ที่ได้รับจากการให้บริการ (หน่วยงาน)
                                </Label>
                                {[
                                    { key: "BorrowReason4P1", text: "1.ให้คำปรึกษา/ชี้แจงหลักเกณฑ์ถูกต้อง ชัดเจน เข้าใจง่าย" },
                                    { key: "BorrowReason4P2", text: "2.อำนวยความสะดวกในการจัดทำเอกสารกู้ยืม" },
                                    { key: "BorrowReason4P3", text: "3.กระตือรือร้นและเต็มใจให้บริการด้วยความรวดเร็ว" },
                                    { key: "BorrowReason4P4", text: "4.สามารถตอบคำถาม ช่วยเหลือเมื่อมีข้อสงสัย" },
                                    { key: "BorrowReason4P5", text: "5.ช่องทางการชำระเงินกู้ยืมสะดวก" },
                                    { key: "BorrowReason4P6", text: "6.ขั้นตอนการให้บริการสะดวก รวดเร็ว" },
                                    { key: "BorrowReason4P7", text: "7.การประชาสัมพันธ์ข้อมูลข่าวสาร" },
                                ].map(({ key, text }) => (
                                    <div className="d-flex justify-content-between border rounded-pill m-1" key={key}>
                                        <div className="mx-3 pt-2">
                                            {text}
                                            {errors[key] ? (
                                                <span className="text-left text-danger mx-1">{errors[key]}</span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id={key}
                                            name={key}
                                            type="select"
                                            disabled
                                            className="rounded-pill w-auto text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values[key]}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                ))}

                                {/* ===== ส่วนที่ 5 ===== */}
                                <Label className="me-4 pt-2 input-color">ส่วนที่ 5 อื่นๆ</Label>
                                <div className="p-3">
                                    {/* 5.1 */}
                                    <Label className="me-4">
                                        1. ท่านมีความประสงค์จะใช้บริการเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานเพิ่มเติมหรือไม่
                                        {errors.BorrowReason51 ? (
                                            <span className="text-left text-danger mx-1">{errors.BorrowReason51}</span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason51"
                                                name="BorrowReason51"
                                                type="radio"
                                                className="cus-type"
                                                disabled
                                                value="1"
                                                checked={String(values.BorrowReason51) === "1"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>ต้องการ</Label>
                                        </Col>
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason51"
                                                name="BorrowReason51"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                disabled
                                                checked={String(values.BorrowReason51) === "2"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>ไม่ต้องการ</Label>
                                        </Col>
                                    </Row>
                                    <Label className="pt-2 px-2">เนื่องจาก</Label>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason511"
                                            name="BorrowReason511"
                                            type="text"
                                            className="text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            disabled
                                            value={values.BorrowReason511}
                                        />
                                    </Col>

                                    {/* 5.2 */}
                                    <Label className="pt-3">
                                        2. อัตราดอกเบี้ยร้อยละ 3 ต่อปี เหมาะสมหรือไม่
                                        {errors.BorrowReason52 ? (
                                            <span className="text-left text-danger mx-1">{errors.BorrowReason52}</span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason52"
                                                name="BorrowReason52"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                disabled
                                                checked={String(values.BorrowReason52) === "1"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>เหมาะสม</Label>
                                        </Col>
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason52"
                                                name="BorrowReason52"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                disabled
                                                checked={String(values.BorrowReason52) === "2"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>ไม่เหมาะสม</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Label className="pt-2 mx-2" sm={4}>
                                            อัตราที่เหมาะสม คือ ร้อยละ
                                        </Label>
                                        <Col sm={2}>
                                            <Input
                                                id="BorrowReason521"
                                                name="BorrowReason521"
                                                type="number"
                                                className="rounded-pill text-center input-color"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                disabled
                                                value={values.BorrowReason521}
                                            />
                                        </Col>
                                        <Label sm={2}>ต่อปี</Label>
                                    </Row>
                                    <Label className="mx-2" sm={2}>
                                        เนื่องจาก
                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason522"
                                            name="BorrowReason522"
                                            type="text"
                                            className="text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            disabled
                                            onChange={handleChange}
                                            value={values.BorrowReason522}
                                        />
                                    </Col>

                                    {/* 5.3 */}
                                    <Label className="pt-3">
                                        3. เงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานมีประโยชน์หรือไม่
                                        {errors.BorrowReason53 ? (
                                            <span className="text-left text-danger mx-1">{errors.BorrowReason53}</span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason53"
                                                name="BorrowReason53"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                checked={String(values.BorrowReason53) === "1"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>มีประโยชน์</Label>
                                        </Col>
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason53"
                                                name="BorrowReason53"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                disabled

                                                checked={String(values.BorrowReason53) === "2"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>ไม่มีประโยชน์</Label>
                                        </Col>
                                    </Row>
                                    <Label className="mx-2" sm={2}>
                                        เนื่องจาก
                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason531"
                                            name="BorrowReason531"
                                            type="text"
                                            disabled

                                            className="text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.BorrowReason531}
                                        />
                                    </Col>

                                    {/* 5.4 */}
                                    <Label className="pt-3">
                                        4. ทราบข่าวสารการให้กู้ยืมจาก
                                        {errors.BorrowReason54 ? (
                                            <span className="text-left text-danger mx-1">{errors.BorrowReason54}</span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col>
                                            <Input
                                                id="BorrowReason54"
                                                name="BorrowReason54"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                disabled

                                                checked={String(values.BorrowReason54) === "1"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>เจ้าหน้าที่กรมพัฒนาฝีมือแรงงาน</Label>
                                        </Col>
                                    </Row>
                                    <Row className="pt-2 px-2">
                                        <Col>
                                            <Input
                                                id="BorrowReason54"
                                                name="BorrowReason54"
                                                type="radio"
                                                disabled

                                                className="cus-type"
                                                value="2"
                                                checked={String(values.BorrowReason54) === "2"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>Internet</Label>
                                        </Col>
                                    </Row>
                                    <Row className="pt-2 px-2">
                                        <Col>
                                            <Input
                                                id="BorrowReason54"
                                                name="BorrowReason54"
                                                type="radio"
                                                className="cus-type"
                                                value="3"
                                                disabled

                                                checked={String(values.BorrowReason54) === "3"}
                                                onChange={handleChange}
                                            />{" "}
                                            <Label>
                                                อื่นๆ โปรดระบุ
                                                {errors.BorrowReason541 ? (
                                                    <span className="text-left text-danger mx-1">{errors.BorrowReason541}</span>
                                                ) : null}
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason541"
                                            name="BorrowReason541"
                                            type="text"
                                            className="text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            disabled

                                            value={values.BorrowReason541}
                                        />
                                    </Col>

                                    {/* 5.5 */}
                                    <Row>
                                        <Label className="pt-3">5. ปัญหาอุปสรรคการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน</Label>
                                        <Col sm={12}>
                                            <Input
                                                id="BorrowReason55"
                                                name="BorrowReason55"
                                                type="text"
                                                className="text-center input-color rounded-pill"
                                                onBlur={handleBlur}
                                                disabled

                                                onChange={handleChange}
                                                value={values.BorrowReason55}
                                            />
                                        </Col>
                                    </Row>

                                    {/* 5.6 */}
                                    <Row>
                                        <Label className="pt-3">6. ข้อคิดเห็นและข้อเสนอแนะ</Label>
                                        <Col sm={12}>
                                            <Input
                                                id="BorrowReason56"
                                                name="BorrowReason56"
                                                type="text"
                                                className="text-center input-color rounded-pill"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                disabled

                                                value={values.BorrowReason56}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                {/* ===== ตารางสรุปค่าใช้จ่าย ===== */}
                                <Row className="pt-2 px-2">
                                    <Label className="me-4 input-color">สรุปค่าใช้จ่ายในการดำเนินการ</Label>
                                    {errors.TdTrainTests ? (
                                        <span className="text-left text-danger mx-1">{errors.TdTrainTests}</span>
                                    ) : null}
                                </Row>
                                <Table className="styled-table" striped bordered hover>
                                    <thead className="text-center" style={{ verticalAlign: "top" }}>
                                        <tr>
                                            <th colSpan={2} rowSpan={2} className="text-center">ลำดับ</th>
                                            <th colSpan={2} rowSpan={2} className="text-center">ชื่อหลักสูตร/สาขาอาชีพ</th>
                                            <th colSpan={2} className="text-center">วงเงินกู้ตามสัญญากู้ยืมเงิน</th>
                                            <th colSpan={3} className="text-center">การใช้จ่ายเงินกู้ยืมตามที่เบิกจ่ายจริง</th>
                                            <th colSpan={3} rowSpan={2} className="text-center">
                                                จำนวนเงินกู้ยืมคงเหลือจากการเบิกจ่ายจริง(ถ้ามี)
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>จำนวนเงิน</th>
                                            <th>จำนวนคนเข้าฝึกอบรม/ทดสอบฯ</th>
                                            <th>จำนวนเงิน</th>
                                            <th>จำนวนคนเข้าฝึกอบรม/ทดสอบฯ</th>
                                            <th>จำนวนผู้ผ่านการฝึกอบรม/ทดสอบฯ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(dataTdTrainTests || []).map((item, i) => (
                                            <tr key={`${item.paymentTypeId}_${item.itemId}`}>
                                                <td colSpan={2} className="text-center">{i + 1}</td>
                                                <td colSpan={2}>{item.itemName}</td>
                                                <td colSpan={1}>{NumberWithCommas(item.paymentAmount || 0)}</td>
                                                <td colSpan={1}>{NumberWithCommas(item.personTotal || 0)}</td>
                                                <td colSpan={1}>
                                                    <Input
                                                        type="text"
                                                        className="text-center input-color rounded-pill"
                                                        name={`a${item.paymentTypeId}_${item.itemId}`}
                                                        id={`a${item.paymentTypeId}_${item.itemId}`}
                                                        value={item.actualPayment ?? 0}
                                                        disabled
                                                        onChange={(e) => setValueTrainTests(e, values, setFieldValue)}
                                                    />
                                                </td>
                                                <td colSpan={1}>
                                                    <Input
                                                        type="text"
                                                        className="text-center input-color rounded-pill"
                                                        name={`p${item.paymentTypeId}_${item.itemId}`}
                                                        id={`p${item.paymentTypeId}_${item.itemId}`}
                                                        value={item.actualPerson ?? 0}
                                                        disabled

                                                        onChange={(e) => setValueTrainTests(e, values, setFieldValue)}
                                                    />
                                                </td>
                                                <td colSpan={1}>
                                                    <Input
                                                        type="text"
                                                        className="text-center input-color rounded-pill"
                                                        name={`r${item.paymentTypeId}_${item.itemId}`}
                                                        id={`r${item.paymentTypeId}_${item.itemId}`}
                                                        value={item.passPerson ?? 0}
                                                        disabled

                                                        onChange={(e) => setValueTrainTests(e, values, setFieldValue)}
                                                    />
                                                </td>
                                                <td colSpan={2}>{NumberWithCommas(item.balanceAmount || 0)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={4}>รวม</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.paymentAmount)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.personTotal)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.actualPayment)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.actualPerson)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.passPerson)}</td>
                                            <td colSpan={2}>{NumberWithCommas(sumTdTrainTests.balanceAmount)}</td>
                                        </tr>
                                    </tfoot>
                                </Table>

                                {/* แนบไฟล์หลักฐาน (ใหม่) */}
                                {/* <div>
                                    <Label className="text-left">หลักฐานการจ่ายค่าใช้จ่ายที่เกี่ยวข้อง</Label>
                                    {errors.fActualExpensePath ? (
                                        <span className="text-left text-danger mx-1">{errors.fActualExpensePath}</span>
                                    ) : null}
                                    <Input
                                        name="fActualExpensePath"
                                        type="file"
                                        onBlur={handleBlur}
                                        disabled
                                        className={
                                            touched.fActualExpensePath && errors.fActualExpensePath
                                                ? "input-error rounded-pill text-center input-color"
                                                : "rounded-pill text-center input-color"
                                        }
                                        onChange={(e) => {
                                            if (e?.target?.files?.[0]) {
                                                setFieldValue("fActualExpensePath", e.target.files[0]);
                                            } else {
                                                setFieldValue("fActualExpensePath", "");
                                            }
                                        }}
                                    />
                                </div> */}

                                {/* ปุ่มบันทึก */}
                                <div className="text-center mt-4">
                                    <button
                                        // disabled={disableButton}
                                        className="submit-btn w-50"
                                        type="button"
                                        onClick={() => submitFormBorrowSix()}
                                    // onClick={() => checkSumActual(values, submitForm, setFieldError)}
                                    >
                                        รับทราบ
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                );
            }}
        </Formik>
    );
}
